import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  TextField,
  Box,
  Typography,
  Button,
  makeStyles,
  FormControl,
  Switch,
  FormGroup,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  Table,
  TableBody,
  Paper,
  Snackbar

} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import BalanceConfirmationDialog from "../../commons/Dialog/BalanceConfirmationDialog";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";
import { Autocomplete } from "@material-ui/lab";
import { formatCurrency } from "../../helpers/currency";
import EnableAddonDialog from "./Addons/EnableAddonDialog";
import { Edit } from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";
import axios from "axios";
import { TENANT_ID, URL as CLIENT_URL } from "../../config/config";

const PLANS = ["SILVER", "GOLD", "DIAMOND"];

const TYPES = ["WHITELABEL", "DIRECT", "ADS_WHITELABEL"];

const INTERNAL_BILLING_TYPES = ["PREPAID", "POSTPAID"];

const ADD_ONS = [
  {
    name: "Single Sign On",
    key: "SSO",
  },
  {
    name: "Webhooks",
    key: "WEBHOOKS",
  },
  {
    name: "Shopify Integration",
    key: "SHOPIFY",
  },
  {
    name: "LeadSquared Integration",
    key: "LEADSQUARED",
  },
  {
    name: "CleverTap Integration",
    key: "CLEVERTAP",
  },
  {
    name: "MoEngage Integration",
    key: "MOENGAGE",
  },
  {
    name: "WebEngage Integration",
    key: "WEBENGAGE",
  },
  {
    name: "Woocommerce Integration",
    key: "WOOCOMMERCE",
  },
  {
    name: "Meta Ads",
    key: "META_ADS",
  },
  {
    name: "Flow Builder",
    key: "FLOW_BUILDER",
  },
  {
    name: "Pabbly Integration",
    key: "PABBLY",
  },
  {
    name: "Razorpay Integration",
    key: "RAZORPAY",
  },
  {
    name: "Whatsapp Pay",
    key: "WHATSAPP_PAY",
  },
  {
    name: "Meta Ads Iframe",
    key: "META_ADS_IFRAME",
  },
  {
    name: "Live Chat Iframe",
    key: "LIVE_CHAT_IFRAME",
  },
  {
    name: "Time To Live",
    key: "TTL"
  },
  {
    name: "Request Encryption",
    key: "ENCRYPTION",
  }
];

const ADS_WHITELABEL_ADD_ONS = [
  {
    name: "Direct API's",
    key: "DIRECT_API",
  },
];

const PARTNERSHIP_STATUS = [
  "ACTIVE",
  "UNPAID",
  "INACTIVE",
  "TERMINATED",
  "STOPPED",
  "CHURNED",
  "BUSINESS_CLOSED",
  "INTERNAL_TESTING",
  "PARTNER_TESTING",
  "HYBRID_PARTNER_CURRENCY",
  "HYBRID_PARTNER_MODEL"
];

const useStyles = makeStyles({
  root: {
    padding: "2rem 1rem",
    backgroundColor: "#EBF5F3",
    borderRadius: "12px",
  },
  textField: {
    backgroundColor: "white",
    border: "1px solid black",
  },

  rechargeTextField: {
    backgroundColor: "white",
    border: "1px solid black",
    "& .MuiInputLabel-formControl": {
      top: 5,
      left: 15,
    },
  },

  selectFieldInput: {
    borderRadius: "8px",
    backgroundColor: "white",
    border: "1px solid black",
    padding: "12px",
  },
});

/**
 * @typedef {import("../../types").Partner} Partner
 */

/**
 * @typedef {Object} PartnerBalanceInputProps
 * @property {Partner} partner
 * @property {(action: 'ADD' | 'SUBTRACT', amount: number) => Promise<void>} updateCentralBalance
 * @property {(key: string, value: string | number) => Promise<void>} updateAttribute
 */

/**
 * @param {PartnerBalanceInputProps} props
 */

function PartnerBalanceInput({
  partner,
  updateCentralBalance,
  updateCentralAdsBalance,
  updateAttribute,
  activateAddon,
  updateAddon,
  disableAddon,
  agent,
  switchPlanType,
  changeTrialSettings,
  trialSetting,
  updatePartnerAutoRecharge,
  hasWriteAccess,
}) {
  const classes = useStyles();

  const [selectedPlan, setSelectedPlan] = useState(partner.planType ?? "");
  const [selectedStatus, setSelectedStatus] = useState(
    partner?.partnershipStatus ?? ""
  );
  const [partnershipStatusRemark, setPartnershipStatusRemark] = useState(
    partner?.partnershipStatusRemark ?? ""
  );
  const [selectedBillingType, setSelectedBillingType] = useState(
    partner?.billingType ?? ""
  );
  // DIRECT or WHITELABEL or ADS_WHITELABEL
  const [selectedType, setSelectedType] = useState(partner.type ?? "");
  const [balanceType, setBalanceType] = useState("PRE-PAID");
  const DISPLAY_ADD_ONS =
    selectedType === "ADS_WHITELABEL" ? ADS_WHITELABEL_ADD_ONS : ADD_ONS;

  // ADD or SUBTRACT
  const [selectedAction, setSelectedAction] = useState("ADD");
  const selectedAddons = partner.addons || {};
  const [activeAddon, setActiveAddon] = useState();
  const [addonDialogVisibility, setAddonVisibility] = useState(false);
  const handleAddonChange = async (event) => {
    const addonKey = event.target.name;
    setActiveAddon(addonKey);
    if (event.target.checked) {
      if (selectedAddons[addonKey]) activateAddon(addonKey);
      else setAddonVisibility(true);
    } else {
      await disableAddon(addonKey);
    }
  };

  // Amount to add or subtract from partner central balance
  const [amount, setAmount] = useState(NaN);
  const [paymentRemark, setPaymentRemark] = useState();
  // Min Allowed Central Balance for PARTNER
  const [minAllowedBalance, setMinAllowedBalance] = useState(NaN);

  // Balance confirmation dialog
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  // Ads balance state
  const [adsAmount, setAdsAmount] = useState(NaN);
  const [adsPaymentRemark, setAdsPaymentRemark] = useState();
  const [adsSelectedAction, setAdsSelectedAction] = useState("ADD");
  const [adsBalanceType, setAdsBalanceType] = useState("PRE-PAID");
  const [showAdsConfirmDialog, setShowAdsConfirmDialog] = useState(false);
  const [KAM, setKAM] = useState([]);
  const [selectedKAM, setSelectedKAM] = useState(null);

  const [kamHistory, setKamHistory] = useState(partner?.kam_update_chain || []);
  const [currentKam, setCurrentKam] = useState(partner?.currentKam || "");

  const [salesExecutiveHistory] = useState(partner?.salesExecutive_update_chain || []);
  const [selectedSalesExecutive, setSelectedSalesExecutive] = useState(null);
  const [currentSalesExecutive, setCurrentSalesExecutive] = useState(partner?.currentSalesExecutive || "");

  const [onboardingExecutiveHistory] = useState(partner?.onboardingExecutive_update_chain || []);
  const [selectedOnboardingExecutive, setSelectedOnboardingExecutive] = useState(null);
  const [currentOnboardingExecutive, setCurrentOnboardingExecutive] = useState(partner?.currentOnboardingExecutive || "");

  // Alert state for success/error messages
  const [alert, setAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const showSuccessMessage = (message) => {
    setAlert(true);
    setAlertMsg(message);
    setAlertSeverity("success");
  };

  const showErrorMessage = (message) => {
    setAlert(true);
    setAlertMsg(message);
    setAlertSeverity("error");
  };

  const closeSnackbar = () => {
    setAlert(false);
    setAlertMsg("");
    setAlertSeverity("");
  };

  useEffect(() => {
    // Fetch KAM list once
    (async () => {
      try {
        const { data } = await axios.get(CLIENT_URL + "/superadmin/get-agents");
        setKAM(data || []);
      } catch (e) {
        setKAM([]);
      }
    })();
  }, []);

  const assignKAM = async () => {
    if (!selectedKAM?.email) return;
    try {
      await axios.post(`${CLIENT_URL}/superadmin/update-partner-attributes`, {
        partnerId: partner._id,
        currentKam: selectedKAM.email,
        updatePayload: {},
      });
      setCurrentKam(selectedKAM.email);
      showSuccessMessage("KAM assigned successfully!");
    } catch (e) {
      showErrorMessage("Unable to assign KAM!");
    }
  };
  const assignSalesExecutive = async () => {
    if (!selectedSalesExecutive?.email) return;
    try {
      await axios.post(`${CLIENT_URL}/superadmin/update-partner-attributes`, {
        partnerId: partner._id,
        currentSalesExecutive: selectedSalesExecutive.email,
        updatePayload: {},
      });
      setCurrentSalesExecutive(selectedSalesExecutive.email);
      showSuccessMessage("Sales Executive assigned successfully!");

    } catch (e) {
      showErrorMessage("Unable to assign sales executive!");

    }
  };

  const assignOnboardingExecutive = async () => {
    if (!selectedOnboardingExecutive?.email) return;
    try {
      await axios.post(`${CLIENT_URL}/superadmin/update-partner-attributes`, {
        partnerId: partner._id,
        currentOnboardingExecutive: selectedOnboardingExecutive.email,
        updatePayload: {},
      });
      setCurrentOnboardingExecutive(selectedOnboardingExecutive.email);
      showSuccessMessage("Onboarding Executive assigned successfully!"); 

    } catch (e) {
      showErrorMessage("Unable to assign onboarding executive!");

    }
  };

  const handleAttriuteUpdate = async (key, value) => {
    await updateAttribute(key, value);
  };

  const [rechargeAmount, setRechargeAmount] = useState(
    partner?.autoRechargeCentralBalance?.rechargeAmount / 100000 || NaN
  );
  const [rechargeThreshold, setRechargeThreshold] = useState(
    partner?.autoRechargeCentralBalance?.rechargeThreshold / 100000 || NaN
  );

  const [rechargeError, setRechargeError] = useState("");
  const [thresholdError, setThresholdError] = useState("");

  return (
    <fieldset
      disabled={!hasWriteAccess}
      style={{ border: "none", padding: 0, margin: 0 }}
    >
      <Box className={classes.root}>
        {/* PARTNER CENTRAL BALANCE */}

        {(TENANT_ID && agent.power >= 10) || hasWriteAccess ? (
          <>
            {" "}
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Add or Subtract Partner Central Balance
            </Typography>
            <Typography variant="body1" gutterBottom>
              Current Balance:{" "}
              {partner.centralBalance
                ? `${formatCurrency(
                  partner.currency,
                  (partner.centralBalance ?? 0) / 100000
                )}`
                : "Nill"}
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={3}>
                <TextField
                  value={amount}
                  onChange={(e) => setAmount(e.target.valueAsNumber)}
                  type="number"
                  placeholder="Amount to be added / subtracted"
                  className={classes.textField}
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={paymentRemark}
                  onChange={(e) => setPaymentRemark(e.target.value)}
                  placeholder="Remark - optional"
                  className={classes.textField}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={2}>
                <NativeSelect
                  fullWidth
                  value={selectedAction}
                  onChange={(e) => setSelectedAction(e.target.value)}
                  input={
                    <InputBase
                      classes={{
                        input: classes.selectFieldInput,
                      }}
                    />
                  }
                >
                  <option value="ADD">ADD</option>
                  <option value="SUBTRACT">SUBTRACT</option>
                </NativeSelect>
              </Grid>

              <Grid item xs={2}>
                <NativeSelect
                  fullWidth
                  value={balanceType}
                  onChange={(e) => setBalanceType(e.target.value)}
                  input={
                    <InputBase
                      classes={{
                        input: classes.selectFieldInput,
                      }}
                    />
                  }
                >
                  <option value="PRE-PAID">PRE-PAID</option>
                  <option value="POST-PAID">POST-PAID</option>
                  <option value="ADJUSTMENTS">ADJUSTMENTS</option>
                  <option value="INCENTIVES">INCENTIVES</option>
                </NativeSelect>
              </Grid>

              <Grid item>
                <Tooltip
                  title={!paymentRemark ? "Please fill out all fields" : ""}
                >
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setShowConfirmDialog(true)}
                      disabled={!paymentRemark}
                    >
                      Modify Balance
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>{" "}
          </>
        ) : (
          <></>
        )}

        {!TENANT_ID ? <Box my={5}>{/* <Divider /> */}</Box> : <></>}

        {/* PARTNER CENTRAL ADS BALANCE */}
        {(((TENANT_ID && agent.power >= 10) || hasWriteAccess) && partner.type === "DIRECT") ? (
          <>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Add or Subtract Partner Central Ads Balance
            </Typography>
            <Typography variant="body1" gutterBottom>
              Current Ads Balance:{" "}
              {partner.centralAdsBalance
                ? `${formatCurrency(
                    partner.currency,
                    (partner.centralAdsBalance ?? 0) / 100000
                  )}`
                : "Nill"}
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={3}>
                <TextField
                  value={adsAmount}
                  onChange={(e) => setAdsAmount(e.target.valueAsNumber)}
                  type="number"
                  placeholder="Amount to be added / subtracted"
                  className={classes.textField}
                  fullWidth
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={adsPaymentRemark}
                  onChange={(e) => setAdsPaymentRemark(e.target.value)}
                  placeholder="Remark - optional"
                  className={classes.textField}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={2}>
                <NativeSelect
                  fullWidth
                  value={adsSelectedAction}
                  onChange={(e) => setAdsSelectedAction(e.target.value)}
                  input={
                    <InputBase
                      classes={{
                        input: classes.selectFieldInput,
                      }}
                    />
                  }
                >
                  <option value="ADD">ADD</option>
                  <option value="SUBTRACT">SUBTRACT</option>
                </NativeSelect>
              </Grid>
              <Grid item xs={2}>
                <NativeSelect
                  fullWidth
                  value={adsBalanceType}
                  onChange={(e) => setAdsBalanceType(e.target.value)}
                  input={
                    <InputBase
                      classes={{
                        input: classes.selectFieldInput,
                      }}
                    />
                  }
                >
                  <option value="PRE-PAID">PRE-PAID</option>
                  <option value="POST-PAID">POST-PAID</option>
                  <option value="ADJUSTMENTS">ADJUSTMENTS</option>
                  <option value="INCENTIVES">INCENTIVES</option>
                </NativeSelect>
              </Grid>
              <Grid item>
                <Tooltip
                  title={!adsPaymentRemark ? "Please fill out all fields" : ""}
                >
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setShowAdsConfirmDialog(true)}
                      disabled={!adsPaymentRemark}
                    >
                      Modify Ads Balance
                    </Button>
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </>
        ) : (
          <></>
        )}

        {!TENANT_ID ? <Box my={5}></Box> : <></>}
        {/* PARTNER MIN ALLOWED BALANCE */}
        <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
          Update Partner Min Allowed Balance
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Min Allowed Balance:{" "}
          {partner.centralBalance
            ? `${formatCurrency(
              partner.currency,
              (partner.minAllowedBalance ?? 0) / 100000
            )}`
            : "Nill"}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <TextField
              value={minAllowedBalance}
              onChange={(e) => setMinAllowedBalance(e.target.valueAsNumber)}
              type="number"
              placeholder="Enter amount to be set as partner min allowed central balance"
              className={classes.textField}
              fullWidth
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                updateAttribute("minAllowedBalance", minAllowedBalance);
                setMinAllowedBalance(NaN);
              }}
            >
              Modify Min Allowed Balance
            </Button>
          </Grid>
        </Grid>
        <Box my={5}>{/* <Divider /> */}</Box>

        <Box py={2} px={0} my={2} className={classes.container}>

          <Box>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Assign Onboarding Executive
            </Typography>

            <Typography variant="body1" gutterBottom>
              Current Onboarding Executive - {currentOnboardingExecutive || partner.currentOnboardingExecutive || "N/A"}
            </Typography>

            <Grid container>
              <Grid item xs={5} alignItems="center">
                <Autocomplete
                  value={selectedOnboardingExecutive}
                  options={KAM || []}
                  getOptionLabel={(option) => option?.name || ""}
                  onChange={(e, value) => setSelectedOnboardingExecutive(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{
                        border: "1px solid ",
                        background: "white",
                        marginRight: 10,
                      }}
                      placeholder={KAM?.length > 0 ? "Select Onboarding Executive" : "Loading Onboarding Executives..."}
                      disabled={!KAM || KAM.length === 0}
                    />
                  )}
                  noOptionsText={KAM?.length === 0 ? "No Sales Executives available" : "Loading..."}
                />
              </Grid>

              <Grid item>
                <Typography variant="body1" gutterBottom>
                  <Button
                    style={{ marginLeft: 10 }}
                    color="primary"
                    variant="contained"
                    onClick={assignOnboardingExecutive}
                  >
                    Assign Onboarding Executive
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box mt={4}>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Onboarding Executive Assign History
            </Typography>

            <TableContainer component={Paper} style={{ width: "100%", maxWidth: 800 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "25%" }}>From</TableCell>
                    <TableCell style={{ width: "25%" }}>To</TableCell>
                    <TableCell style={{ width: "30%" }}>Updated By</TableCell>
                    <TableCell style={{ width: "30%" }}>Updated On</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {onboardingExecutiveHistory
                    .slice()
                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.from || "N/A"}</TableCell>
                        <TableCell>{row.to || "N/A"}</TableCell>
                        <TableCell>{row.updatedBy}</TableCell>
                        <TableCell>
                          {row.updatedAt
                            ? new Date(row.updatedAt).toLocaleString()
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </Box>
        {/* KAM section aligned left and placed after Auto Recharge */}
        <Box py={2} px={0} my={2} className={classes.container}>

          <Box>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Assign Sales Executive
            </Typography>

            <Typography variant="body1" gutterBottom>
              Current Sales Executive - {currentSalesExecutive || partner.currentSalesExecutive || "N/A"}
            </Typography>

            <Grid container>
              <Grid item xs={5} alignItems="center">
                <Autocomplete
                  value={selectedSalesExecutive}
                  options={KAM || []}
                  getOptionLabel={(option) => option?.name || ""}
                  onChange={(e, value) => setSelectedSalesExecutive(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{
                        border: "1px solid ",
                        background: "white",
                        marginRight: 10,
                      }}
                      placeholder={KAM?.length > 0 ? "Select Sales Executive" : "Loading Sales Executives..."}
                      disabled={!KAM || KAM.length === 0}
                    />
                  )}
                  noOptionsText={KAM?.length === 0 ? "No Sales Executives available" : "Loading..."}
                />
              </Grid>

              <Grid item>
                <Typography variant="body1" gutterBottom>
                  <Button
                    style={{ marginLeft: 10 }}
                    color="primary"
                    variant="contained"
                    onClick={assignSalesExecutive}
                  >
                    Assign Sales Executive
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box mt={4}>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Sales Executive Assign History
            </Typography>

            <TableContainer component={Paper} style={{ width: "100%", maxWidth: 800 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "25%" }}>From</TableCell>
                    <TableCell style={{ width: "25%" }}>To</TableCell>
                    <TableCell style={{ width: "30%" }}>Updated By</TableCell>
                    <TableCell style={{ width: "30%" }}>Updated On</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {salesExecutiveHistory
                    .slice()
                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.from || "N/A"}</TableCell>
                        <TableCell>{row.to || "N/A"}</TableCell>
                        <TableCell>{row.updatedBy}</TableCell>
                        <TableCell>
                          {row.updatedAt
                            ? new Date(row.updatedAt).toLocaleString()
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </Box>

        <Box py={2} px={0} my={2} className={classes.container}>

          <Box>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              Assign KAM
            </Typography>

            <Typography variant="body1" gutterBottom>
              Current KAM - {currentKam || partner.currentKam || "N/A"}
            </Typography>

            <Grid container>
              <Grid item xs={5} alignItems="center">
                <Autocomplete
                  value={selectedKAM}
                  options={KAM || []}
                  getOptionLabel={(option) => option?.name || ""}
                  onChange={(e, value) => setSelectedKAM(value)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      style={{
                        border: "1px solid ",
                        background: "white",
                        marginRight: 10,
                      }}
                      placeholder={KAM?.length > 0 ? "Select KAM" : "Loading KAMs..."}
                      disabled={!KAM || KAM.length === 0}
                    />
                  )}
                  noOptionsText={KAM?.length === 0 ? "No KAMs available" : "Loading..."}
                />
              </Grid>

              <Grid item>
                <Typography variant="body1" gutterBottom>
                  <Button
                    style={{ marginLeft: 10 }}
                    color="primary"
                    variant="contained"
                    onClick={assignKAM}
                  >
                    Assign KAM
                  </Button>
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Box mt={4}>
            <Typography
              variant="body1"
              gutterBottom
              style={{ fontWeight: "bold" }}
            >
              KAM Assign History
            </Typography>

            <TableContainer component={Paper} style={{ width: "100%", maxWidth: 800 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "25%" }}>From</TableCell>
                    <TableCell style={{ width: "25%" }}>To</TableCell>
                    <TableCell style={{ width: "30%" }}>Updated By</TableCell>
                    <TableCell style={{ width: "30%" }}>Updated On</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {kamHistory
                    .slice()
                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                    .map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.from || "N/A"}</TableCell>
                        <TableCell>{row.to || "N/A"}</TableCell>
                        <TableCell>{row.updatedBy}</TableCell>
                        <TableCell>
                          {row.updatedAt
                            ? new Date(row.updatedAt).toLocaleString()
                            : ""}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </Box>

        {/* PARTNERSHIP STATUS */}
        <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
          Change Partnership Status
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Partnership Status -{" "}
          {partner?.partnershipStatus?.toUpperCase() || "Nill"}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <Autocomplete
              disableClearable
              options={PARTNERSHIP_STATUS.map((option) => option)}
              onChange={(e, value, reason) =>
                setSelectedStatus(value.toLowerCase())
              }
              value={selectedStatus.toUpperCase()}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.textField}
                  InputProps={{ ...params.InputProps }}
                  placeholder="Select partnership status"
                  style={{
                    border: "1px solid ",
                    background: "white",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              name="partnershipStatusRemark"
              value={partnershipStatusRemark}
              onChange={(e) => setPartnershipStatusRemark(e.target.value)}
              placeholder="Enter Remark (Required)"
              className={classes.textField}
              fullWidth
              variant="outlined"
              size="small"
              style={{ padding: "0px" }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={async () => {
                await updateAttribute("partnershipStatus", selectedStatus);
                await updateAttribute(
                  "partnershipStatusRemark",
                  partnershipStatusRemark
                );
              }}
              disabled={
                !selectedStatus ||
                !partnershipStatusRemark.trim() ||
                (selectedStatus === (partner?.partnershipStatus ?? "") &&
                  partnershipStatusRemark ===
                  (partner?.partnershipStatusRemark ?? ""))
              }
            >
              Update Status
            </Button>
          </Grid>
        </Grid>
        <Box my={5}>{/* <Divider /> */}</Box>

        {/* PARTNER INTERNAL BILLING TYPE */}
        <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
          Change Billing Type
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Billing Type - {partner?.billingType || "Nill"}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Autocomplete
              disableClearable
              options={INTERNAL_BILLING_TYPES.map((option) => option)}
              onChange={(e, value, reason) => {
                if (reason === "select-option") {
                  setSelectedBillingType(value);
                }
              }}
              value={selectedBillingType}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.textField}
                  InputProps={{ ...params.InputProps }}
                  placeholder="Select internal billing type"
                  style={{
                    border: "1px solid ",
                    background: "white",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() =>
                updateAttribute("billingType", selectedBillingType)
              }
            >
              Update Billing Type
            </Button>
          </Grid>
        </Grid>
        <Box my={5}>{/* <Divider /> */}</Box>

        {/* PARTNER PLAN TYPE */}
        <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
          Change Partner Plan Type
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Plan Type - {partner.planType || "Nill"}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Autocomplete
              disableClearable
              options={PLANS.map((option) => option)}
              onChange={(e, value, reason) => setSelectedPlan(value)}
              value={selectedPlan}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.textField}
                  InputProps={{ ...params.InputProps }}
                  placeholder="Select plan type"
                  style={{
                    border: "1px solid ",
                    background: "white",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => switchPlanType(selectedPlan)}
            >
              Update Plan
            </Button>
          </Grid>
        </Grid>
        <Box my={5}>{/* <Divider /> */}</Box>
        {/* PARTNER TYPE */}
        <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
          Change Partner Type (WHITELABEL or DIRECT)
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Type - {partner.type || "Nill"}
        </Typography>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Autocomplete
              disableClearable
              options={TYPES.map((option) => option)}
              onChange={(e, value, reason) => {
                if (reason == "select-option") {
                  setSelectedType(value);
                }
              }}
              value={selectedType}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.textField}
                  InputProps={{ ...params.InputProps }}
                  placeholder="Select plan"
                  style={{
                    border: "1px solid ",
                    background: "white",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleAttriuteUpdate("type", selectedType)}
            >
              Change Type
            </Button>
          </Grid>
        </Grid>

        <Box my={6}></Box>

        {!TENANT_ID ? (
          <>
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="body1" style={{ fontWeight: "bold" }}>
                  Central Balance Auto Recharge
                </Typography>
              </Grid>

              <Grid item>
                <Tooltip
                  title={
                    !rechargeAmount || isNaN(parseInt(rechargeThreshold))
                      ? "All fields are required!"
                      : ""
                  }
                >
                  <span>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={
                            partner?.autoRechargeCentralBalance?.isEnabled ||
                            false
                          }
                          onChange={() => {
                            updatePartnerAutoRecharge(
                              !partner?.autoRechargeCentralBalance?.isEnabled,
                              rechargeAmount,
                              rechargeThreshold
                            );

                            if (
                              partner?.autoRechargeCentralBalance?.isEnabled
                            ) {
                              setRechargeAmount(NaN);
                              setRechargeThreshold("");
                            }
                          }}
                          disabled={
                            !rechargeAmount ||
                            isNaN(parseInt(rechargeThreshold))
                          }
                          color="primary"
                        />
                      }
                    />
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
            <Typography variant="body1" gutterBottom>
              Auto-recharge partner's CB when it drops below the balance
              threshold value.
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={3}>
                <TextField
                  id="standard-basic"
                  label="Auto Recharge Amount"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  className={classes.rechargeTextField}
                  value={rechargeAmount}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (isNaN(value) || value <= 0) {
                      setRechargeError("Please enter a valid amount");
                      setRechargeAmount(NaN);
                    } else if (value > 5000000) {
                      setRechargeError("Amount cannot exceed 50,00,000");
                      setRechargeAmount(NaN);
                    } else {
                      setRechargeError("");
                      setRechargeAmount(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (
                      ["e", "E", "+", "-", ".", " "].includes(e.key) ||
                      e.key === "Space"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  pattern="[0-9]*"
                  type="number"
                  fullWidth
                  error={!!rechargeError}
                  helperText={rechargeError}
                  inputProps={{
                    min: 1,
                    step: 1,
                    maxLength: 7,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="standard-basic"
                  label="Recharge Threshold"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  className={classes.rechargeTextField}
                  value={rechargeThreshold}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (isNaN(value)) {
                      setThresholdError("Please enter a valid number");
                      setRechargeThreshold("");
                    } else {
                      setThresholdError("");
                      setRechargeThreshold(value);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "-" && e.target?.value?.includes("-")) {
                      e.preventDefault();
                    }
                    if (
                      ["e", "E", "+", ".", " "].includes(e.key) ||
                      e.key === "Space"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  fullWidth
                  type="number"
                  error={!!thresholdError}
                  helperText={thresholdError}
                />
              </Grid>

              {partner?.autoRechargeCentralBalance?.isEnabled && (
                <Tooltip
                  title={
                    !rechargeAmount || isNaN(parseInt(rechargeThreshold))
                      ? "Please fill out all fields"
                      : ""
                  }
                >
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        updatePartnerAutoRecharge(
                          partner?.autoRechargeCentralBalance?.isEnabled,
                          rechargeAmount,
                          rechargeThreshold
                        );
                      }}
                      disabled={
                        !rechargeAmount || isNaN(parseInt(rechargeThreshold))
                      }
                    >
                      Update
                    </Button>
                  </span>
                </Tooltip>
              )}
            </Grid>
          </>
        ) : (
          <></>
        )}

        <Box my={6}></Box>
        <Grid item xs={12} md={12}>
          <Box>
            {/* <Box mt={3} /> */}
            <Grid container alignItems="center">
              <Grid md={10} xs={10}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Signup Management
                </Typography>
              </Grid>
              <Grid md={2} xs={2}>
                <Grid container>
                  <Switch
                    checked={!!trialSetting?.enableSignUp}
                    name="enableSignUp"
                    onChange={(e) => changeTrialSettings(e)}
                    color="primary"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box>
            {/* <Box mt={3} /> */}
            <Grid container alignItems="center">
              <Grid md={10} xs={10}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Trial Management
                </Typography>
              </Grid>
              <Grid md={2} xs={2}>
                <Grid container>
                  <Switch
                    checked={!!trialSetting?.enableTrial}
                    name="enableTrial"
                    onChange={(e) => changeTrialSettings(e)}
                    color="primary"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box>
            {/* <Box mt={3} /> */}
            <Grid container alignItems="center">
              <Grid md={10} xs={10}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Free WCC credit Management
                </Typography>
              </Grid>
              <Grid md={2} xs={2}>
                <Grid container>
                  <Switch
                    checked={!!trialSetting?.enableTrialAmount}
                    name="enableTrialAmount"
                    onChange={(e) => changeTrialSettings(e)}
                    color="primary"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Box>
            {/* <Box mt={3} /> */}
            <Grid container alignItems="center">
              <Grid md={10} xs={10}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Meta Ads Without API
                </Typography>
              </Grid>
              <Grid md={2} xs={2}>
                <Grid container>
                  <Switch
                    checked={!!trialSetting?.enableMetaAdsWithoutAPI}
                    name="enableMetaAdsWithoutAPI"
                    onChange={(e) => changeTrialSettings(e)}
                    color="primary"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Box my={5}>{/* <Divider /> */}</Box>
        <Typography variant="body1" gutterBottom style={{ fontWeight: "bold" }}>
          Add or Remove Addons
        </Typography>
        <Typography variant="body1" gutterBottom>
          Current Addons -{" "}
          {Object.keys(selectedAddons)
            .filter((key) => selectedAddons[key]?.status === "active")
            .map((key) => selectedAddons[key].name)
            .join(", ")}
        </Typography>
        <FormControl component="fieldset">
          <FormGroup row>
            {DISPLAY_ADD_ONS.map((addon) => {
              return (
                <FormControlLabel
                  control={
                    <Grid container alignItems="center">
                      <Grid
                        item
                        xs={
                          selectedAddons[addon.key]?.status === "active"
                            ? 6
                            : 12
                        }
                        style={{
                          display: "flex",
                          justifyContent:
                            selectedAddons[addon.key]?.status === "active"
                              ? "flex-end"
                              : "center",
                        }}
                      >
                        <Switch
                          checked={
                            selectedAddons[addon.key]?.status === "active"
                          }
                          onChange={handleAddonChange}
                          name={addon.key}
                          color="primary"
                        />
                      </Grid>
                      {selectedAddons[addon.key]?.status === "active" && (
                        <Grid item xs={6}>
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setActiveAddon(addon.key);
                              setAddonVisibility(true);
                            }}
                          >
                            <Edit />
                          </IconButton>
                        </Grid>
                      )}
                    </Grid>
                  }
                  label={addon.name}
                  labelPlacement="bottom"
                />
              );
            })}
          </FormGroup>
        </FormControl>
        {addonDialogVisibility && (
          <EnableAddonDialog
            open={addonDialogVisibility}
            onClose={() => {
              setAddonVisibility(false);
            }}
            addonKey={activeAddon}
            addon={selectedAddons[activeAddon]}
            activateAddon={activateAddon}
            modifyAddon={updateAddon}
            classes={classes}
          />
        )}

        <BalanceConfirmationDialog
          open={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          amount={amount}
          action={selectedAction}
          balanceType={balanceType}
          remark={paymentRemark}
          currency={partner.currency}
          onConfirm={() => {
            updateCentralBalance(
              selectedAction,
              amount,
              paymentRemark,
              balanceType
            );
            setAmount(NaN);
            setPaymentRemark(undefined);
            setShowConfirmDialog(false);
          }}
        />
        <BalanceConfirmationDialog
          open={showAdsConfirmDialog}
          onClose={() => setShowAdsConfirmDialog(false)}
          amount={adsAmount}
          action={adsSelectedAction}
          balanceType={adsBalanceType}
          remark={adsPaymentRemark}
          currency={partner.currency}
          onConfirm={() => {
            updateCentralAdsBalance(
              adsSelectedAction,
              adsAmount,
              adsPaymentRemark,
              adsBalanceType
            );
            setAdsAmount(NaN);
            setAdsPaymentRemark(undefined);
            setShowAdsConfirmDialog(false);
          }}
        />
      </Box>
      <Snackbar
        open={alert}
        autoHideDuration={4000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={alertSeverity}
        >
          {alertMsg}
        </Alert>
      </Snackbar>
    </fieldset>
  );
}
const connectedPartnerBalanceInput = connect((state) => ({
  agent: state.login.user,
}))(PartnerBalanceInput);
export default connectedPartnerBalanceInput;
